import React from "react";

interface LoadingProps {
  size?: "sm" | "md" | "lg";
  color?: "primary" | "gray" | "white";
  text?: string;
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = "md",
  color = "primary",
  text,
  className = "",
}) => {
  // Size mappings
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12",
  };

  // Color mappings
  const colorClasses = {
    primary: "border-base-100 border-t-transparent",
    gray: "border-base-300 border-t-transparent",
    white: "border-base-100 border-t-transparent",
  };

  // Text size mappings
  const textSizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
  };

  return (
    <div
      className={`flex flex-col items-center justify-center space-y-2 ${className}`}
    >
      <div
        className={`
          ${sizeClasses[size]} 
          ${colorClasses[color]}
          border-2 
          rounded-full 
          animate-spin
        `}
      />
      {text && (
        <p
          className={`
          ${textSizeClasses[size]} 
          ${color === "white" ? "text-white" : "text-base-content/80"} 
          font-medium
        `}
        >
          {text}
        </p>
      )}
    </div>
  );
};

export default Loading;
